import React from "react";
import './CustomerDetailsContainer.scss';
import homelaneLogo from '../assets/icons/homelane.png'
import doowupLogo from '../assets/icons/doowup.png'
import handle1Img from './images/hing1.png';
import { connect } from "react-redux";
import EditIcon from "components/editIcon";
import {inputDqcData,exportDrawing} from './../actions/wizard'
import {ReactComponent as WrapzapLogo} from '../assets/icons/wrapzapLogo.svg';
import {ReactComponent as CubicoLogo} from '../assets/icons/cubicoLogo.svg';
import {ReactComponent as DesignCafeLogo } from '../assets/icons/designCafeLogo.svg';


class CustomerDetailsContainer extends React.Component<any, any>{
    onEditDqc = () =>{
        this.props.inputDqcData({isDqcDataPresent:false,dqcUpdateMode:true,dqcAddMode:false});
       // this.props.exportDrawing({projectData:this.props.projectData});
    }
    render() {
        const { customer_details, type, notes, roomName,pageDetails,exportDrawingStatus,previewMode,orderProfileType} = this.props;
        const customerDetails = customer_details;
        let essentialNotes = pageDetails?.essentialNotes;
        let custDetailKeys = [];
        if(customerDetails)
           custDetailKeys = Object.keys(customerDetails); 
        return (
            <div className="page-right-container">
                <div className="customer-details">
                    <ul className="customer-details-list">
                        {
                            orderProfileType ? ( orderProfileType ==='DOOWUP' ? <img  src={doowupLogo} alt="Logo" className={'hlLogo'}/> :  orderProfileType === 'WRAPZAP' ? <WrapzapLogo /> : customerDetails?.displayProfile?.toLowerCase() === 'cubico' ? <CubicoLogo className={'hlLogo'} /> : ['dc', 'designcafe'].includes(orderProfileType?.toLowerCase()) ? <DesignCafeLogo /> : <img  alt="Logo" src={homelaneLogo} className={'hlLogo'}/>): ""
                        }
                         <li className="customer-details-list-item" key={0}>
                                <span className="right-container-heading">{`2D Drawing - ${roomName ? roomName: ""}`}</span>
                        </li>    
                        {
                            custDetailKeys.length  && custDetailKeys.map((key, index)=>{
                                const value = customerDetails[key];
                                let ckey = key.replace(/_/g, " ");
                                if(typeof value == 'object'){
                                    return (
                                        <li className="customer-details-list-item" key={index}>
                                            <span className="right-container-heading"><b>{ckey}</b>{(key==='DQC_Manager'&& previewMode !== 'enabled' && exportDrawingStatus !== 'inprogress') && <EditIcon onClick={this.onEditDqc}/>}</span>
                                            <span className="content">{value?.name}</span><br/>
                                            <span className="content">{value?.emailId}</span> 
                                         </li>
                                    )
                                }
                                return(
                                    <li className="customer-details-list-item" key={index}>
                                        <p className="right-container-heading"><b>{ckey}</b></p>
                                        <span className="content">{value}</span>
                                    </li>
                                )  
                            })
                        }                    
                    </ul>
                </div>
                {
                    
                    essentialNotes ? <div className="roomPageNotes"><span>Notes</span>
                        {
                            (essentialNotes || "").split('\n').map(i => {
                                return <p key={i}>{i.trim()}</p>
                            })
                        }
                    </div> : notes ? <div className="roomPageNotes"><span>Notes</span>
                        {
                            (notes || "").split('\n').map(i => {
                                return <p key={i}>{i.trim()}</p>
                            })
                        }
                    </div> :""
                }
                {
                    type === "elevation2" ?
                        <div className="sidebar-image">
                            <div className="hing-heading">HING/HANDLE POSITION</div>
                            <img className="hing-image" crossOrigin="anonymous" src={handle1Img ? `${handle1Img}?ver=${new Date().getTime()}`:""} alt="handleImage"></img>
                        </div>
                    :"" 
                }
            </div>
        )
    }

}
export default connect(
    (state: any) => ({
        customer_details: state.wizard.customer_details,
        isDqcDataPresent:state.wizard.isDqcDataPresent,
        projectData: state.wizard.projectData,
        pageDetails: state.wizard.pageDetails,
        notes: state.wizard.notes,
        roomName: state.wizard.roomName,
        exportDrawingStatus: state.wizard.exportDrawingStatus,
        previewMode: state.wizard.previewMode,
        orderProfileType: state.wizard.orderProfileType
    }),
    {      
        inputDqcData,
        exportDrawing
    }
)(CustomerDetailsContainer);